import React, { useState, useEffect } from 'react';
import axios from 'axios'; // For API calls (install: npm install axios)

const QuestionsManagement = () => {
  const [questions, setQuestions] = useState([]);
  const [newQuestion, setNewQuestion] = useState({ question: '', answer: '' });
  const [editQuestionId, setEditQuestionId] = useState(null);
  const [editedQuestion, setEditedQuestion] = useState({ question: '', answer: '' });
  const [file, setFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState(null);

  useEffect(() => {
    fetchQuestions();
  }, []);

  const fetchQuestions = async () => {
    try {
      const response = await axios.get('/api/questions'); // Replace with your API endpoint
      setQuestions(response.data);
    } catch (error) {
      console.error('Error fetching questions:', error);
    }
  };

  const handleInputChange = (e) => {
    setNewQuestion({ ...newQuestion, [e.target.name]: e.target.value });
  };

  const handleAddQuestion = async () => {
    try {
      await axios.post('/api/questions', newQuestion); // Replace with your API endpoint
      setNewQuestion({ question: '', answer: '' });
      fetchQuestions();
    } catch (error) {
      console.error('Error adding question:', error);
    }
  };

  const handleDeleteQuestion = async (id) => {
    try {
      await axios.delete(`/api/questions/${id}`); // Replace with your API endpoint
      fetchQuestions();
    } catch (error) {
      console.error('Error deleting question:', error);
    }
  };

  const handleEditQuestion = (question) => {
    setEditQuestionId(question.id);
    setEditedQuestion({ question: question.question, answer: question.answer });
  };

  const handleUpdateInputChange = (e) => {
    setEditedQuestion({ ...editedQuestion, [e.target.name]: e.target.value });
  };

  const handleUpdateQuestion = async () => {
    try {
      await axios.put(`/api/questions/${editQuestionId}`, editedQuestion); // Replace with your API endpoint
      setEditQuestionId(null);
      fetchQuestions();
    } catch (error) {
      console.error('Error updating question:', error);
    }
  };

  const handleCancelEdit = () => {
    setEditQuestionId(null);
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleBulkUpload = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      setUploadStatus('Uploading...');
      await axios.post('/api/questions/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }); // Replace with your API endpoint
      setUploadStatus('Upload successful!');
      fetchQuestions();
      setFile(null);
    } catch (error) {
      console.error('Error uploading file:', error);
      setUploadStatus('Upload failed.');
    } finally {
      setTimeout(() => setUploadStatus(null), 3000); // Clear status after 3 seconds
    }
  };

  return (
    <div className="p-4">

<div className="flex gap-4">
    <p>Select Project: </p>
    <select name="" id="" className='select select-bordered'>
        <option value="">Select</option>
    </select>
</div>
<div className="flex gap-4">
    <p>Select Survey: </p>
    <select name="" id="" className='select select-bordered'>
        <option value="">Select</option>
    </select>
</div>

      <h2 className="text-2xl font-bold mb-4">Questions Management</h2>

      {/* Add Question */}
      <div className="mb-4">
        <h3 className="text-lg font-semibold mb-2">Add Question</h3>
        <input
          type="text"
          name="question"
          value={newQuestion.question}
          onChange={handleInputChange}
          placeholder="Question"
          className="border p-2 mr-2"
        />
        <input
          type="text"
          name="answer"
          value={newQuestion.answer}
          onChange={handleInputChange}
          placeholder="Answer"
          className="border p-2 mr-2"
        />
        <button onClick={handleAddQuestion} className="bg-blue-500 text-white p-2">
          Add
        </button>
      </div>

      {/* Bulk Upload */}
      <div className="mb-4">
        <h3 className="text-lg font-semibold mb-2">Bulk Upload Questions</h3>
        <input type="file" onChange={handleFileChange} className="mb-2" />
        <button onClick={handleBulkUpload} className="bg-green-500 text-white p-2">
          Upload
        </button>
        {uploadStatus && <p className="mt-2">{uploadStatus}</p>}


        <div className="">
            <button className="btn text-green-400">Download Template</button>
        </div>
      </div>

      {/* Question List */}
      <div>
        <h3 className="text-lg font-semibold mb-2">Questions List</h3>
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2">Question</th>
              <th className="border p-2">Answer</th>
              <th className="border p-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {questions.map((question) => (
              <tr key={question.id}>
                <td className="border p-2">
                  {editQuestionId === question.id ? (
                    <input
                      type="text"
                      name="question"
                      value={editedQuestion.question}
                      onChange={handleUpdateInputChange}
                      className="border p-1"
                    />
                  ) : (
                    question.question
                  )}
                </td>
                <td className="border p-2">
                  {editQuestionId === question.id ? (
                    <input
                      type="text"
                      name="answer"
                      value={editedQuestion.answer}
                      onChange={handleUpdateInputChange}
                      className="border p-1"
                    />
                  ) : (
                    question.answer
                  )}
                </td>
                <td className="border p-2">
                  {editQuestionId === question.id ? (
                    <>
                      <button onClick={handleUpdateQuestion} className="bg-blue-500 text-white p-1 mr-1">
                        Save
                      </button>
                      <button onClick={handleCancelEdit} className="bg-gray-400 text-white p-1">
                        Cancel
                      </button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => handleEditQuestion(question)} className="bg-yellow-500 text-white p-1 mr-1">
                        Edit
                      </button>
                      <button onClick={() => handleDeleteQuestion(question.id)} className="bg-red-500 text-white p-1">
                        Delete
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default QuestionsManagement;